<!-- 分页组件 -->
<template>
  <!-- 分页 -->
  <div
    :style="{ width: table_scroll_width + 'px' }"
    style="text-align: center; margin-top: 41px"
  >
    <div
      style="
        text-align: center;
        margin-top: 30px;
        position: sticky;
        left: 30px;
        z-index: 13;
      "
      :style="{ width: table_null_width + 'px' }"
    >
      <a-pagination
        v-model="p_page"
        :pageSize="r_limit"
        :total="table_total"
        :showTotal="(total, range) => `共 ${total} 条`"
        :pageSizeOptions="['3', '5', '8', '10', '12', '15', '20', '30']"
        @change="pagingChange"
        show-quick-jumper
        show-size-changer
        @showSizeChange="onShowSizeChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "pagingCompont",
  props: [
    "table_scroll_width",
    "table_null_width",
    "table_total",
    "r_page",
    "r_limit",
  ],
  data() {
    return {};
  },
  computed: {
    p_page: {
      get() {
        return this.r_page;
      },
      set(val) {},
    },
  },
  methods: {
    pagingChange(e) {
      this.$emit("pagination-Change", e);
    },
    onShowSizeChange(current, pageSize) {
      // console.log(current, pageSize);
      // this.r_limit = pageSize
      this.$emit("change-size-limit", pageSize);
    },
  },
};
</script>

<style scoped></style>
